export default function StepWizard({ step, total }) {
  return <div className="mb-4"><div className="mb-2 flex justify-between text-xs text-tg-hint"><span>Step {step}</span><span>{total}</span></div><div className="h-2 rounded-full bg-white/10"><div className="h-2 rounded-full bg-violet-600" style={{ width: `${(step / total) * 100}%` }} /></div></div>;
}
